import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import { Sellauthorization } from "src/components/sell-authorization/sell-authorization";
import styles from "../../components/navbar/navbarOne.module.scss";
import { closeEdisModal } from "src/redux/reducers/modals";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
const SellAuth = () => {
    const dispatch = useAppDispatch();
    const edisData = useAppSelector((state) => {
        return state.modals.edisData;
    });
    const [IsSellAuthModalOpen, setSellAuthModalOpen] = useState(false);
    useEffect(() => {
        setSellAuthModalOpen(edisData != undefined);
    }, [edisData]);
    return (_jsx(_Fragment, { children: IsSellAuthModalOpen && (_jsx(Modal, Object.assign({ isOpen: IsSellAuthModalOpen, onRequestClose: () => {
                dispatch(closeEdisModal());
            }, className: `${styles.myCommonModal} ${styles.sellAuthModalWrapper} `, overlayClassName: styles.myCommonOverlay }, { children: _jsx(Sellauthorization, { exchange: (edisData === null || edisData === void 0 ? void 0 : edisData.exchange) ? edisData === null || edisData === void 0 ? void 0 : edisData.exchange : "N", exchangeType: (edisData === null || edisData === void 0 ? void 0 : edisData.exchangeType) ? edisData === null || edisData === void 0 ? void 0 : edisData.exchangeType : "D", scripCode: (edisData === null || edisData === void 0 ? void 0 : edisData.scripCode) ? edisData === null || edisData === void 0 ? void 0 : edisData.scripCode : 1, quantity: (edisData === null || edisData === void 0 ? void 0 : edisData.quantity) ? edisData.quantity : 0 }) }))) }));
};
export default SellAuth;
